export const UserAdminRole = 'UserAdmin';
export const SubAdminRole = 'SubAdmin';
export const ClientAdminRole = 'ClientAdmin';
export const EE123Role = 'EE123.edit';
export const EE123SalariesRole = 'EE123Salaries.edit';
export const EE123PeopleRole_Edit = 'EE123People.edit';
export const EE123PeopleRole_View = 'EE123People.view';
export const BEE123SalariesRole = 'TrainingRelatedSalaries.edit';
export const AuditRole = 'Audit';
export const ClientRole = 'Client';
export const UserRole = 'User';
export const SiteAdminRole = 'SiteAdministration';
export const ScorecardAdmin = 'ScorecardAdmin';
export const PeopleViewRole = 'People.view';
export const PeopleEditRole = 'People.edit';
export const PlatformPeopleViewRole = 'PlatformPeople.view';
export const PlatformPeopleEditRole = 'PlatformPeople.edit';
export const PlatformPeopleSalaryViewRole = 'PlatformPeopleSalary.view';
export const PlatformPeopleSalaryEditRole = 'PlatformPeopleSalary.edit';
export const AdvisoryRole = 'Advisory';
export const AdvancedSupplierModuleRole = 'AdvancedSupplierModule';
export const StrategicRelationshipManagerRole = 'StrategicRelationshipManager';
export const BEELockScorecards = 'LockScorecards.edit';
export const VAExportEditRole = 'VAExport.edit';
export const VAUser = 'VAUser';

